export { default } from './SWCarouselIcons';
